import { useEffect, useLayoutEffect, useState } from "react";
import Sidebar from "../../pages/Sidebar";
import "./header.css";
import { NavLink, Link } from "react-router-dom";
import logo from "../../assets/logo.png";
import menu from "../../assets/menu.png";

const SIGN_IN_LINK = "https://sync.beatoven.ai/";
const SIGN_UP_LINK = "https://sync.beatoven.ai/?action=signup";

const Header = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [abValue, setAb] = useState("control");
  const toggleSideBar = () => {
    setShowSidebar(!showSidebar);
  };
  useLayoutEffect(() => {
    //toggleSideBar();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (showSidebar) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  });

  const trackOutboundLink = (event, label, href, extra={}) => {

    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    window.dataLayer.push({
      event: "custom_event",
      eventModel: {
        event_action: label,
        event_category: 'signin-signup',
        event_label: label,
        value: abValue,
        non_interaction: false,
      },
      eventCallback : function() {
        if(label == "Sign_In") {
          window.location.href = href + '?source=' + abValue ;
        } else {
          window.location.href = href + '&source=' + abValue ;
        }
      },
      eventTimeout : 100,
      ...extra,
    });

    event.preventDefault();
    return true;
  }

  return (
    <>
      <header>
        <div className="Navlinks">
          <Link to="/">
            <img src={logo} alt="beatoven.ai" className="logo" width="220" height="auto" />
          </Link>
          <div className="navlinks">
            <ul>
              <li>
                <NavLink to="/how-it-works" className="links" activeClassName="active">
                  How It Works
                </NavLink>
              </li>
              <li>
                <NavLink to="/pricing" className="links" activeClassName="active">
                  Pricing
                </NavLink>
              </li>
              <li>
                <NavLink to="/artists" className="links" activeClassName="active">
                  Artists
                </NavLink>
              </li>
              <li>
                <NavLink to="/community" className="links" activeClassName="active">
                  Community
                </NavLink>
              </li>
              <li>
                <NavLink to="/api" className="links" activeClassName="active">
                  API
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <img
            src={menu}
            alt="menu"
            class="toggle"
            width="45"
            height="45"
            onClick={toggleSideBar}
          />
        </div>

        <div className="navlinks_right">
          <a href={`${SIGN_IN_LINK}`} onClick={e => trackOutboundLink(e, "Sign_In", SIGN_IN_LINK)} target="_blank" rel="noreferrer" className="border-2 px-2 py-0.5 rounded-lg">
            SIGN IN
          </a>
          <a
            href={`${SIGN_UP_LINK}`}
            target="_blank"
            rel="noreferrer"
            className="navbutton navbtn_link"
            onClick={e => trackOutboundLink(e, "SIGNUP-CTA-1", SIGN_UP_LINK )}
          >
            SIGN UP - It's free!
          </a>
        </div>
      </header>
      {showSidebar && <Sidebar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />}
    </>
  );
};

export default Header;
